<div class="page-header border-bottom">
    <h3>Emergency Contacts</h3>
</div>
<div class="container">
    <div class="row">
        <a routerLink="/careers/tasks" class="btn btn-primary" style="margin-bottom:15px;">
            <span><i class="modus-icons align-bottom">chevron_left</i></span> Back
        </a>
    </div>
    <div style="position:fixed;text-align:left;z-index:100;margin-top:-25px;">
        <span *ngIf="lastSave.status == 'success' && lastSave.time != null" class="badge badge-success default" [ngClass]="{fade: formData.labelFade}">Save Successful - {{lastSave.time}}</span>
        <span *ngIf="lastSave.status == 'danger' && lastSave.time != null" class="badge badge-danger default" [ngClass]="{fade: formData.labelFade}">Save Fail - {{lastSave.time}}</span>
    </div>
    <div class="row">
        <quill-view [content]="oNECTaskCustomText" style="margin-bottom: 10px;"></quill-view>
        <table class="table" *ngIf="contactList?.length > 0">
            <thead>
                <tr>
                    <th>Name</th>
                    <th>Relationship</th>
                    <th>Home Phone</th>
                    <th>Cell Phone</th>
                    <th>Work Phone</th>
                    <th>Note</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let row of contactList">
                    <tr>
                        <td>{{row.ContactName}}</td>
                        <td>{{row.Relationship}}</td>
                        <td>{{row.HomePhone}}</td>
                        <td>{{row.CellPhone}}</td>
                        <td>{{row.WorkPhone}}</td>
                        <td>{{row.Note}}</td>
                        <td><button type="button" class="btn btn-success" (click)="expendRow(row)">Edit</button></td>
                    </tr>
                    <tr *ngIf="row.Expended">
                        <td colspan="6">
                            <div class="card border" style="margin-bottom:20px;">
                                <div class="card-body">
                                    <form #rowContact="ngForm" ngbAutofocus>
                                        <div class="row" style="margin-bottom:10px;">
                                            <div class="col-lg-3">
                                                <label><strong>Contact Name</strong></label>
                                                <input type="text" class="form-control" name="contactname" maxlength="30" [(ngModel)]="row.ContactName" [required]="true" [ngClass]="{invalidField: row.ContactName == null}" />
                                            </div>
                                            <div class="col-lg-2">
                                                <label><strong>Relationship</strong></label>
                                                <div *ngIf="relationshipList?.length > 0">
                                                    <ng-select [(ngModel)]="row.Relationship" [required]="true" [ngClass]="{invalidField: row.Relationship == null}" [searchable]="false" [clearable]="false">
                                                        <ng-option *ngFor="let data of relationshipList" [value]="data.DisplayValue">{{data.DisplayValue}}</ng-option>
                                                    </ng-select>
                                                </div>
                                                <div *ngIf="relationshipList?.length < 1">
                                                    <input type="text" class="form-control" name="relationship" [(ngModel)]="row.Relationship" maxlength="30" [required]="true" [ngClass]="{invalidField: row.Relationship == null || row.Relationship == ''}" />
                                                </div>
                                            </div>
                                            <div class="col-lg-2">
                                                <label><strong>Home Phone</strong></label>
                                                <input type="text" class="form-control" name="homephone" [(ngModel)]="row.HomePhone" placeholder="{{phoneMask}}" appPhoneFormat (valueChange)="updateRowPhone(row, $event, 'HomePhone')" />
                                            </div>
                                            <div class="col-lg-2">
                                                <label><strong>Cell Phone</strong></label>
                                                <input type="text" class="form-control" name="cellphone" [(ngModel)]="row.CellPhone" placeholder="{{phoneMask}}" appPhoneFormat (valueChange)="updateRowPhone(row, $event, 'CellPhone')" />
                                            </div>
                                            <div class="col-lg-2">
                                                <label><strong>Work Phone</strong></label>
                                                <input type="text" class="form-control" name="workphone" [(ngModel)]="row.WorkPhone" placeholder="{{phoneMask}}" appPhoneFormat (valueChange)="updateRowPhone(row, $event, 'WorkPhone')" />
                                            </div>
                                        </div>
                                        <div class="row" style="margin-bottom:10px;">
                                            <div class="col-lg-5">
                                                <label><strong>Address</strong></label>
                                                <input type="text" class="form-control" name="address" maxlength="60" [(ngModel)]="row.Address" />
                                            </div>
                                            <div class="col-lg-3">
                                                <label><strong>City</strong></label>
                                                <input type="text" class="form-control" name="city" maxlength="30" [(ngModel)]="row.City" />
                                            </div>
                                            <div class="col-lg-2">
                                                <label *ngIf="country != 'CAN'"><strong>State</strong></label>
                                                <label *ngIf="country == 'CAN'"><strong>Province</strong></label>
                                                <ng-select [(ngModel)]="row.State" name="state" [searchable]="false" [clearable]="false">
                                                    <ng-option *ngFor="let data of stateList" [value]="data.DatabaseValue">{{data.DisplayValue}}</ng-option>
                                                </ng-select>
                                            </div>
                                            <div class="col-lg-2">
                                                <label *ngIf="country != 'CAN'"><strong>Zip</strong></label>
                                                <label *ngIf="country == 'CAN'"><strong>Postal Code</strong></label>
                                                <input type="text" class="form-control" name="zip" maxlength="12" [(ngModel)]="row.Zip" appUSZipFormat (valueChange)="updateZip($event,row)" />
                                            </div>
                                        </div>
                                        <div class="row" style="margin-bottom:10px;">
                                            <div class="col-lg-12">
                                                <label><strong>Note</strong></label>
                                                <input type="text" class="form-control" name="note" [(ngModel)]="row.Note" />
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-lg-12">
                                                <button type="button" class="btn btn-danger" (click)="deleteContact(row)">Delete</button>
                                                <button type="button" class="btn btn-success" (click)="saveContact(row)" [disabled]="rowContact.form.invalid" style="float:right;">Save</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
    </div>
    <div>
        <div class="row card border">
            <div class="card-header bg-light" (click)="expendAddNew()" style="cursor:pointer;">
                <span *ngIf="!formData.expendAddNew"><i class="modus-icons align-bottom">chevron_right_thick</i></span>
                <span *ngIf="formData.expendAddNew"><i class="modus-icons align-bottom">expand_more_bold</i></span>
                <strong>Add New Contact</strong>
            </div>
            <div class="card-body" *ngIf="formData.expendAddNew">
                <form #newContact="ngForm" ngbAutofocus>
                    <div class="row" style="margin-bottom:10px;">
                        <div class="col-lg-3">
                            <label><strong>Contact Name</strong></label>
                            <input type="text" name="ContactName" class="form-control" maxlength="30" [(ngModel)]="formData.ContactName" [required]="true" [ngClass]="{invalidField: formData.ContactName == null}" />
                        </div>
                        <div class="col-lg-2">
                            <label><strong>Relationship</strong></label>
                            <div *ngIf="relationshipList?.length > 0">
                                <ng-select [(ngModel)]="formData.Relationship" name="Relationship" [required]="true" [ngClass]="{invalidField: formData.Relationship == null}" [searchable]="false" [clearable]="false">
                                    <ng-option *ngFor="let data of relationshipList" [value]="data.DisplayValue">{{data.DisplayValue}}</ng-option>
                                </ng-select>
                            </div>
                            <div *ngIf="relationshipList?.length < 1">
                                <input type="text" class="form-control" name="Relationship" [(ngModel)]="formData.Relationship" maxlength="30" [required]="true" [ngClass]="{invalidField: formData.Relationship == null || formData.Relationship == ''}" />
                            </div>
                        </div>
                        <div class="col-lg-2">
                            <label><strong>Home Phone</strong></label>
                            <input type="text" class="form-control" name="HomePhone" [(ngModel)]="formData.HomePhone" placeholder="{{phoneMask}}" appPhoneFormat (valueChange)="updatePhone($event, 'HomePhone')" />
                        </div>
                        <div class="col-lg-2">
                            <label><strong>Cell Phone</strong></label>
                            <input type="text" class="form-control" name="CellPhone" [(ngModel)]="formData.CellPhone" placeholder="{{phoneMask}}" appPhoneFormat (valueChange)="updatePhone($event, 'CellPhone')" />
                        </div>
                        <div class="col-lg-2">
                            <label><strong>Work Phone</strong></label>
                            <input type="text" class="form-control" name="WorkPhone" [(ngModel)]="formData.WorkPhone" placeholder="{{phoneMask}}" appPhoneFormat (valueChange)="updatePhone($event, 'WorkPhone')" />
                        </div>
                    </div>
                    <div class="row" style="margin-bottom:10px;">
                        <div class="col-lg-5">
                            <label><strong>Address</strong></label>
                            <input type="text" name="Address" class="form-control" maxlength="60" [(ngModel)]="formData.Address" />
                        </div>
                        <div class="col-lg-3">
                            <label><strong>City</strong></label>
                            <input type="text" name="City" class="form-control" maxlength="30" [(ngModel)]="formData.City" />
                        </div>
                        <div class="col-lg-2">
                            <label *ngIf="country != 'CAN'"><strong>State</strong></label>
                            <label *ngIf="country == 'CAN'"><strong>Province</strong></label>
                            <ng-select [(ngModel)]="formData.State" name="State" [searchable]="false" [clearable]="false">
                                <ng-option *ngFor="let data of stateList" [value]="data.DatabaseValue">{{data.DisplayValue}}</ng-option>
                            </ng-select>
                        </div>
                        <div class="col-lg-2">
                            <label *ngIf="country != 'CAN'"><strong>Zip</strong></label>
                            <label *ngIf="country == 'CAN'"><strong>Postal Code</strong></label>
                            <input type="text" class="form-control" maxlength="12" [(ngModel)]="formData.Zip" name="Zip" appUSZipFormat (valueChange)="updateZip($event,formData)" />
                        </div>
                    </div>
                    <div class="row" style="margin-bottom:10px;">
                        <div class="col-lg-12">
                            <label><strong>Note</strong></label>
                            <input type="text" name="Note" class="form-control" [(ngModel)]="formData.Note" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <button type="button" class="btn btn-success" (click)="addNewContact()" [disabled]="newContact.form.invalid" style="float:right;">Save</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>